exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-wrapper[data-v-60f35ab6]{position:relative;height:100%;width:100%}.app-wrapper[data-v-60f35ab6]:after{content:\"\";display:table;clear:both}.app-wrapper.mobile.openSidebar[data-v-60f35ab6]{position:fixed;top:0}.drawer-bg[data-v-60f35ab6]{background:#000;opacity:0.3;width:100%;top:0;height:100%;position:absolute;z-index:999}.ai-img[data-v-60f35ab6]{top:100px;right:10px;position:absolute;width:42px;height:42px;z-index:99999}\n", ""]);

// exports
